module.exports = __webpack_public_path__ + "media/images/classic_assignmentGray-6cb1804e3e545bef6f759aa1da4717d3.svg";